export enum PressReleasePdfType {
  COTAchievement = 'COTAchievement',
  LifeAchievement = 'LifeAchievement',
  MDRTAchievement = 'MDRTAchievement',
  MDRTFoundationGrant = 'MDRTFoundationGrant',
  TOTAchievement = 'TOTAchievement',
}
